import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Message from "../components/LoadingError/Error";
import Loading from "../components/LoadingError/Loading";
import Header from "./../components/Header";
import { login } from "./../Redux/Actions/userActions";
import MobileNav from "../components/MobileNav";

const Login = ({ location, history }) => {
  // window.scrollTo(0, 0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();
  const redirect = location.search ? location.search.split("=")[1] : "/";

  const userLogin = useSelector((state) => state.userLogin);
  const { error, loading, userInfo } = userLogin;

  useEffect(() => {
    if (userInfo) {
      history.push(redirect);
    }
  }, [userInfo, history, redirect]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login(email, password));
  };

  return (
    <>
      <Header />
      <MobileNav />

      <div className="container d-flex flex-column justify-content-center align-items-center login-center">
        {error && <Message variant="alert-danger">{error}</Message>}
        {loading && <Loading />}
        <form
          className="Login col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <input
            type="text"
            placeholder="Email / Mobile"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            minLength={10}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={4}

          />
          <button type="submit">Login</button>
          <p>
            <Link className="Login-a" to={`/login-otp`}>Login Using OTP</Link>
          </p>
          <p>
            <Link
              to={redirect ? `/register?redirect=${redirect}` : "/register"}
            >
              Create New Account
            </Link>
          </p>
          <p className="privacy-policy-links">
          By continuing, you agree to our <Link to="/term-condition"> Terms of service </Link> & <Link to="/policy">Privacy policy </Link> 
          </p>
        </form>
      </div>
    </>
  );
};

export default Login;
